import { render, staticRenderFns } from "./LKRoadmapsFeedAttentionDrop.vue?vue&type=template&id=6c06b936&"
import script from "./LKRoadmapsFeedAttentionDrop.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedAttentionDrop.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedAttentionDrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports